export default function () {

    // Global window functions
    window.googleMapsGeocode = function(address, callback) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( { 'address': address, 'region': 'US' }, function(results, status) {
            callback(results, status, address);
        });
    };
    window.googleMapsZipGeocode = function(zip, callback) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( { 'componentRestrictions': { 'postalCode' : zip }, 'region': 'US' }, function(results, status) {
            callback(results, status, zip);
        });
    };
    window.googleMapsReverseGeocode = function(lat, lng, callback) {
        let geocoder = new google.maps.Geocoder();
        geocoder.geocode( { 'location': {'lat': lat, 'lng': lng} }, callback);
    };

    // Utility function specifically for Google Maps API responses
    window.findAddressComponentType = function(ad, type) {
        let response;
        for (let i = 0; i < ad.length; i++) {
            if(ad[i].types.includes(type)) {
                return ad[i];
            }
        }
    };

    // Find groups map
    if(document.getElementById('find-map') !== null) {
        
        window.findMap = new google.maps.Map(document.getElementById('find-map'), {
            center: {lat: 39.8333333, lng: -98.585522}, // Geographic center of continental US
            zoom: 4,
            disableDefaultUI: true
        });

        window.findMapCircle = null;
        window.findMapPins = [];

    }

};